import React from "react";

const ModeSwitch = ({ isPublicPage, handleSwitchChange }) => (
  <div className="flex items-center mb-4">
    <label className="mr-2 font-bold">Mode:</label>
    <button
      onClick={handleSwitchChange}
      className={`px-4 py-2 rounded ${
        isPublicPage ? "bg-blue-500 text-white" : "bg-gray-200 text-black"
      }`}
    >
      {isPublicPage ? "Public Page" : "Admin Page"}
    </button>
  </div>
);

export default ModeSwitch;
